import _classCallCheck from "/codebuild/output/src448955211/src/Scavenger-Website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src448955211/src/Scavenger-Website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src448955211/src/Scavenger-Website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src448955211/src/Scavenger-Website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src448955211/src/Scavenger-Website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Color, MeshDepthMaterial, NearestFilter, NoBlending, RGBADepthPacking, ShaderMaterial, UniformsUtils, WebGLRenderTarget } from 'three';
import { Pass, FullScreenQuad } from '../postprocessing/Pass.js';
import { BokehShader } from '../shaders/BokehShader.js';
/**
 * Depth-of-field post-process with bokeh shader
 */

var BokehPass = /*#__PURE__*/function (_Pass) {
  _inherits(BokehPass, _Pass);

  var _super = _createSuper(BokehPass);

  function BokehPass(scene, camera, params) {
    var _this;

    _classCallCheck(this, BokehPass);

    _this = _super.call(this);
    _this.scene = scene;
    _this.camera = camera;
    var focus = params.focus !== undefined ? params.focus : 1.0;
    var aspect = params.aspect !== undefined ? params.aspect : camera.aspect;
    var aperture = params.aperture !== undefined ? params.aperture : 0.025;
    var maxblur = params.maxblur !== undefined ? params.maxblur : 1.0; // render targets

    var width = params.width || window.innerWidth || 1;
    var height = params.height || window.innerHeight || 1;
    _this.renderTargetDepth = new WebGLRenderTarget(width, height, {
      minFilter: NearestFilter,
      magFilter: NearestFilter
    });
    _this.renderTargetDepth.texture.name = 'BokehPass.depth'; // depth material

    _this.materialDepth = new MeshDepthMaterial();
    _this.materialDepth.depthPacking = RGBADepthPacking;
    _this.materialDepth.blending = NoBlending; // bokeh material

    if (BokehShader === undefined) {
      console.error('THREE.BokehPass relies on BokehShader');
    }

    var bokehShader = BokehShader;
    var bokehUniforms = UniformsUtils.clone(bokehShader.uniforms);
    bokehUniforms['tDepth'].value = _this.renderTargetDepth.texture;
    bokehUniforms['focus'].value = focus;
    bokehUniforms['aspect'].value = aspect;
    bokehUniforms['aperture'].value = aperture;
    bokehUniforms['maxblur'].value = maxblur;
    bokehUniforms['nearClip'].value = camera.near;
    bokehUniforms['farClip'].value = camera.far;
    _this.materialBokeh = new ShaderMaterial({
      defines: Object.assign({}, bokehShader.defines),
      uniforms: bokehUniforms,
      vertexShader: bokehShader.vertexShader,
      fragmentShader: bokehShader.fragmentShader
    });
    _this.uniforms = bokehUniforms;
    _this.needsSwap = false;
    _this.fsQuad = new FullScreenQuad(_this.materialBokeh);
    _this._oldClearColor = new Color();
    return _this;
  }

  _createClass(BokehPass, [{
    key: "render",
    value: function render(renderer, writeBuffer, readBuffer
    /*, deltaTime, maskActive*/
    ) {
      // Render depth into texture
      this.scene.overrideMaterial = this.materialDepth;
      renderer.getClearColor(this._oldClearColor);
      var oldClearAlpha = renderer.getClearAlpha();
      var oldAutoClear = renderer.autoClear;
      renderer.autoClear = false;
      renderer.setClearColor(0xffffff);
      renderer.setClearAlpha(1.0);
      renderer.setRenderTarget(this.renderTargetDepth);
      renderer.clear();
      renderer.render(this.scene, this.camera); // Render bokeh composite

      this.uniforms['tColor'].value = readBuffer.texture;
      this.uniforms['nearClip'].value = this.camera.near;
      this.uniforms['farClip'].value = this.camera.far;

      if (this.renderToScreen) {
        renderer.setRenderTarget(null);
        this.fsQuad.render(renderer);
      } else {
        renderer.setRenderTarget(writeBuffer);
        renderer.clear();
        this.fsQuad.render(renderer);
      }

      this.scene.overrideMaterial = null;
      renderer.setClearColor(this._oldClearColor);
      renderer.setClearAlpha(oldClearAlpha);
      renderer.autoClear = oldAutoClear;
    }
  }]);

  return BokehPass;
}(Pass);

export { BokehPass };